import { Phone, MessageCircle } from 'lucide-react';

const DesktopFloatingButtons = () => {
  const phoneNumber = '+919205891804';
  const whatsappNumber = '919205891804';
  const whatsappMessage = encodeURIComponent('Hi! I would like to inquire about your luxury architecture and interior design services.');

  return (
    // Show only on desktop (1024px and up)
    <div className="hidden lg:flex fixed bottom-8 right-8 z-50 flex-col gap-4">
      {/* Schedule Call Button - Black */}
      <a
        href={`tel:${phoneNumber}`}
        className="group relative overflow-hidden bg-black text-white px-6 py-4 rounded-full font-bold text-sm flex items-center gap-3 shadow-2xl hover:shadow-black/40 hover:scale-105 active:scale-95 transition-all duration-300 border border-gray-800"
        data-testid="desktop-floating-call"
        title="Schedule a Call"
      >
        {/* Shine effect overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000"></div>
        
        <Phone className="w-5 h-5 group-hover:rotate-12 transition-transform duration-300 relative z-10" />
        <span className="uppercase tracking-[0.15em] relative z-10 whitespace-nowrap">Schedule Call</span>
        
        {/* Subtle inner glow on hover */}
        <div className="absolute inset-0 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500" style={{boxShadow: 'inset 0 0 20px rgba(255,255,255,0.1)'}}></div>
      </a>

      {/* WhatsApp Button - White with Black Border */}
      <a
        href={`https://wa.me/${whatsappNumber}?text=${whatsappMessage}`}
        target="_blank"
        rel="noopener noreferrer"
        className="group relative overflow-hidden bg-white text-black px-6 py-4 rounded-full font-bold text-sm flex items-center gap-3 shadow-2xl hover:shadow-gray-400/40 hover:scale-105 active:scale-95 transition-all duration-300 border-2 border-black"
        data-testid="desktop-floating-whatsapp"
        title="Chat on WhatsApp"
      >
        {/* Shine effect overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-black/5 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000"></div>
        
        <MessageCircle className="w-5 h-5 group-hover:scale-110 transition-transform duration-300 relative z-10" />
        <span className="uppercase tracking-[0.15em] relative z-10 whitespace-nowrap">WhatsApp</span>
        
        {/* Hover subtle background */}
        <div className="absolute inset-0 rounded-full bg-black opacity-0 group-hover:opacity-5 transition-opacity duration-300"></div>
      </a>
    </div>
  );
};

export default DesktopFloatingButtons;
